import * as XLSX from 'xlsx';
import { Subject, takeUntil } from 'rxjs';
import { Component, ElementRef, HostBinding, OnInit, OnDestroy, DoCheck } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Location } from '@angular/common';
import moment from 'moment';
import momentJalaali from 'moment-jalaali';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
// import moment from 'moment';
// import momentJalaali from 'moment-jalaali';
declare let $: any;
@Component({
    selector: 'Income',
    templateUrl: './Income.component.html',
})
export class IncomeComponent implements OnInit, OnDestroy, DoCheck {
    constructor(private el: ElementRef, private notifyService: NotificationService, private router: Router, public otherService: OtherService, private route: ActivatedRoute, private formBuilder: FormBuilder, private _location: Location, private gurdService: GurdServiceService) { }
    Id: number = 0;
    Income: any[] = [];
    totalIncomde: number = 0;
    EditeMod: boolean = false;
    datatTa: FormGroup = this.formBuilder.group({
        date: momentJalaali().format('jYYYY/jMM/jDD'),
    });
    dataAz: FormGroup = this.formBuilder.group({
        date: momentJalaali().subtract(1, 'month').format('jYYYY/jMM/jDD'),
    });
    datasabt: FormGroup = this.formBuilder.group({
        date: momentJalaali().format('jYYYY/jMM/jDD'),
    });
    serchModel: FormGroup = this.formBuilder.group({
        strComment: new FormControl(),
    });
    sabtModel: FormGroup = this.formBuilder.group({
        iAmount: new FormControl(),
        strComment: new FormControl(''),
        iCarRvenues: new FormControl(),
    });
    ngOnInit(): void {
        $('#exampleModal').on('hidden.bs.modal.vehicleRecords', () => {
            this.close();
        });
        this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
            this.Id = params['id'];
        });
        this.getAllIncom();
    }
    seprator(e: any) {
        if (isNaN(e.key)) {
            return false;
        }
        this.otherService.insertComma(e);
        return true;
    }
    goBack() {
        this._location.back();
    }
    getAllIncom = async (strSDate?: string, strEDate?: string, strComment?: string) => {
        if (this.destroyed)
            return;
        if (this.listLoading)
            return;
        this.listLoading = true;
        this.hasError = false;
        this.errorMessage = '';
        try {
            this.totalIncomde = 0;
            if (strSDate !== undefined || strEDate !== undefined || strComment !== undefined) {
                this.incomeQuery = { strSDate: strSDate || '', strEDate: strEDate || '', strComment: strComment || '' };
            }
            var model = {
                strUnitID: this.Id,
                ...this.incomeQuery,
                iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
                strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),
            };
            const resp = await this.post(`GetCarRvenuessNew`, model);
            if (resp.data.ISSessionExpired == true) {
                this.notifyService.showError('لطفا وارد سیستم شوید');
                this.otherService.removeLocalStorage();
                // this.router.navigate(['login']);
                this.router.navigate(['login'], { queryParams: { error: '101' } });
                return;
            }
            if (resp.data.length == 0) {
                this.notifyService.showInfo('داده ای برای نمایش موجود نیست', '');
                this.Income = this.requireRows(resp.data);
            }
            else {
                this.Income = this.requireRows(resp.data);
                this.Income.forEach((element: any) => {
                    this.totalIncomde += element.iAmount;
                });
            }
        }
        catch (error) {
            if (!this.destroyed) {
                this.hasError = true;
                this.errorMessage = error instanceof Error ? error.message : 'دریافت اطلاعات ناموفق بود';
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
        finally {
            this.listLoading = false;
        }
    };
    sabt = async () => {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            var model = this.sabtModel.value;
            model.strDate = this.datasabt.value.date;
            model.strUnitId = this.Id;
            if (model.iAmount == null || model.iAmount == '' || model.iAmount <= 0) {
                this.notifyService.showError('لطفا مقدار هزینه را وارد کنید');
                return;
            }
            model.iAmount = parseFloat(String(model.iAmount).replace(/,/g, ''));
            if (confirm('آیا از ثبت اطلاعات اطمینان دارید؟')) {
                const session = encodeURIComponent(this.gurdService.decrypt(window.localStorage.getItem('Session')!));
                const resp = await this.post(`SaveCarRvenues?iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`, model);
                if (resp.data == -100) {
                    this.notifyService.showError('لطفا وارد سیستم شوید');
                    this.otherService.removeLocalStorage();
                    this.router.navigate(['login']);
                    return;
                }
                if (resp.data == 0) {
                    this.notifyService.showError('خطایی رخ داده');
                }
                if (resp.data == 1) {
                    this.notifyService.showSuccess('با موفقیت ثبت شد');
                    this.getAllIncom();
                    $('#exampleModal').modal('hide');
                }
            }
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    };
    serch() {
        var model = this.serchModel.value;
        this.getAllIncom(this.dataAz.value.date, this.datatTa.value.date, model.strComment);
    }
    getSingel = async (Id: any) => {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            this.datasabt.controls['date'].setValue(this.Income[Id].strDate);
            this.sabtModel.controls['strComment'].setValue(this.Income[Id].strComment);
            this.sabtModel.controls['iAmount'].setValue(this.Income[Id].iAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
            this.sabtModel.controls['iCarRvenues'].setValue(this.Income[Id].iCarRvenues);
            $('#exampleModal').modal('show');
            this.EditeMod = true;
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    };
    edit = async () => {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            var model = this.sabtModel.value;
            model.strDate = this.datasabt.value.date;
            model.strUnitId = this.Id;
            if (model.iAmount == null || model.iAmount == '' || model.iAmount <= 0) {
                this.notifyService.showError('لطفا مقدار هزینه را وارد کنید');
                return;
            }
            model.iAmount = parseFloat(String(model.iAmount).replace(/,/g, ''));
            //model.iAmount= model.iAmount.replace(/,(?=\d{3})/g, '');
            if (confirm('آیا از ویرایش اطلاعات اطمینان دارید؟')) {
                const session = encodeURIComponent(this.gurdService.decrypt(window.localStorage.getItem('Session')!));
                const resp = await this.post(`EditCarRvenues?iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`, model);
                if (resp.data == -100) {
                    this.notifyService.showError('لطفا وارد سیستم شوید');
                    this.otherService.removeLocalStorage();
                    this.router.navigate(['login']);
                    return;
                }
                if (resp.data == 0) {
                    this.notifyService.showError('خطایی رخ داده');
                    this.sabtModel.reset();
                }
                if (resp.data == 1) {
                    this.notifyService.showSuccess('با موفقیت ثبت شد');
                    this.getAllIncom();
                    $('#exampleModal').modal('hide');
                }
            }
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    };
    deleteIncom = async () => {
        if (this.destroyed)
            return;
        if (this.loading)
            return;
        try {
            if (confirm('آیا از حذف اطلاعات اطمینان دارید؟')) {
                var Id = this.sabtModel.value.iCarRvenues;
                var model = {
                    iCarRvenues: Id,
                };
                const session = encodeURIComponent(this.gurdService.decrypt(window.localStorage.getItem('Session')!));
                const resp = await this.post(`DeleteCarRvenues?iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`, model);
                if (resp.data == -100) {
                    this.notifyService.showError('لطفا وارد سیستم شوید');
                    this.otherService.removeLocalStorage();
                    this.router.navigate(['login']);
                    return;
                }
                if (resp.data == -1) {
                    this.notifyService.showError('خطایی رخ داده');
                    this.sabtModel.reset();
                }
                if (resp.data == 1) {
                    this.notifyService.showSuccess('با موفقیت حذف شد');
                    $('#exampleModal').modal('hide');
                    this.Income = this.Income.filter(function (el: any) {
                        return el.iCarRvenues != Id;
                    });
                }
            }
        }
        catch (error) {
            if (!this.destroyed) {
                this.notifyService.showError(error instanceof Error ? error.message : 'خطا در ارتباط با سرور');
            }
        }
    };
    close() {
        this.sabtModel.reset({
            strComment: '',
        });
        this.datasabt.reset({
            date: momentJalaali().format('jYYYY/jMM/jDD'),
        });
        this.EditeMod = false;
    }
    open() {
        this.close();
    }
    guid(Id: any) {
        this.otherService.guid(Id);
    }
    private readonly destroy$ = new Subject<void>();
    private destroyed = false;
    private pendingRequests = 0;
    private listLoading = false;
    private incomeQuery = { strSDate: '', strEDate: '', strComment: '' };
    hasError = false;
    errorMessage = '';
    get loading(): boolean { return this.pendingRequests > 0 || this.listLoading; }
    get tableLoading(): boolean { return this.listLoading; }
    filtersOpen = false;
    get hasRecordFilters(): boolean { return !!this.serchModel.value.strComment?.trim(); }
    async resetRecordFilters(): Promise<void> {
        if (this.loading)
            return;
        const today = momentJalaali().format('jYYYY/jMM/jDD');
        this.dataAz.patchValue({ date: today });
        this.datatTa.patchValue({ date: today });
        this.serchModel.patchValue({ strComment: '' });
        await this.getAllIncom('', '', '');
    }
    async onRecordAction(key: string, row: Record<string, unknown>): Promise<void> {
        if (this.loading || this.destroyed)
            return;
        if (key === 'edit')
            await this.getSingel(this.Income.indexOf(row));
    }

    searchText = '';
    currentPage = 1;
    pageSize = 20;
    readonly pageSizeOptions = [10, 20, 50];
    filteredRows: Record<string, unknown>[] = [];
    pagedRows: Record<string, unknown>[] = [];
    totalAmount = 0;
    private tableSnapshot: unknown[] = [];
    private tableIdentity = '';
    readonly tableTitle = 'لیست درآمدها';
    get printId(): string { return `income-print-${this.Id}`; }
    get hasActiveFilters(): boolean { return !!this.searchText.trim() || this.hasRecordFilters; }
    get emptyTitle(): string {
        return this.hasActiveFilters ? 'با این فیلترها نتیجه‌ای پیدا نشد!' : 'اطلاعاتی برای نمایش وجود ندارد';
    }

    ngDoCheck(): void {
        const identity = `${this.Id}`;
        const rows = this.Income;
        const identityChanged = identity !== this.tableIdentity;
        if (identityChanged) this.searchText = '';
        if (identityChanged || rows.length !== this.tableSnapshot.length || rows.some((row, index) => row !== this.tableSnapshot[index])) {
            this.tableIdentity = identity;
            this.refreshTable(true);
        }
    }

    onSearchChange(): void {
        if (!this.loading) this.refreshTable(true);
    }

    clearSearch(): void {
        if (this.loading) return;
        this.searchText = '';
        this.refreshTable(true);
        if (this.hasRecordFilters) void this.resetRecordFilters();
    }

    onPageChange(page: number): void {
        if (this.loading) return;
        this.currentPage = page;
        this.refreshTable();
    }

    onPageSizeChange(size: number): void {
        if (this.loading || !this.pageSizeOptions.includes(size)) return;
        this.pageSize = size;
        this.refreshTable(true);
    }

    numberValue(value: unknown): number {
        const number = Number(value);
        return Number.isFinite(number) ? number : 0;
    }

    private normalizeSearch(value: unknown): string {
        return String(value ?? '').replace(/[۰-۹]/g, digit => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)))
            .replace(/[٠-٩]/g, digit => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit))).trim().toLowerCase();
    }

    private refreshTable(resetPage = false): void {
        const rows = this.Income;
        this.tableSnapshot = [...rows];
        const fields = ["strDate","iAmount","strComment"];
        const query = this.normalizeSearch(this.searchText);
        this.filteredRows = query
            ? rows.filter(row => this.normalizeSearch(fields.map(field => row[field]).join(' ')).includes(query))
            : [...rows];
        this.currentPage = resetPage ? 1 : Math.max(1, Math.min(this.currentPage, Math.ceil(this.filteredRows.length / this.pageSize) || 1));
        this.pagedRows = this.filteredRows.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
        this.totalAmount = this.filteredRows.reduce((sum, row) => sum + this.numberValue(row['iAmount']), 0);
    }

    exportExcel(): void {
        if (this.loading || this.hasError || !this.filteredRows.length) return;
        const headers = ["#","تاریخ","مبلغ (تومان)","توضیحات"];
        const rows: (string | number)[][] = this.filteredRows.map((row, index) =>
            [index + 1, String(row['strDate'] ?? ''), this.numberValue(row['iAmount']), String(row['strComment'] ?? '')]);
        rows.push([`تعداد کل: ${this.filteredRows.length}`, '', this.totalAmount, '']);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet([headers, ...rows]), 'Sheet1');
        XLSX.writeFile(workbook, `${this.tableTitle}.xlsx`);
    }

    private parse(data: unknown): ReturnType<typeof JSON.parse> {
        return typeof data === 'string' ? JSON.parse(data) : data;
    }
    private requireRows(data: unknown): Record<string, unknown>[] {
        const parsed = this.parse(data);
        if (!Array.isArray(parsed))
            throw new Error(parsed?.strError || 'پاسخ سرور نامعتبر است');
        return parsed;
    }
    private async post(url: string, payload?: unknown) {
        if (this.destroyed)
            throw new Error('درخواست لغو شد');
        this.pendingRequests++;
        try {
            const response = await axios.post(url, payload);
            if (this.destroyed)
                throw new Error('درخواست لغو شد');
            const parsed = this.parse(response.data);
            if (parsed === -100 || parsed?.ISSessionExpired || parsed?.ISessionExpired) {
                this.otherService.removeLocalStorage();
                void this.router.navigate(['login']);
                throw new Error('لطفا وارد سیستم شوید');
            }
            return response;
        }
        finally {
            this.pendingRequests--;
        }
    }
    ngOnDestroy(): void {
        this.destroyed = true;
        this.destroy$.next();
        this.destroy$.complete();
        $(this.el.nativeElement).find('.modal').off('.vehicleRecords').modal('hide');
    }
}
